import React from 'react';
import { DragOverlay, useDndContext } from '@dnd-kit/core';
import { Item } from '../../../AssetBucketingResults/components/Bucket/components/Item/Item';

export const AssetDragOverlay = () => {
  const { active } = useDndContext();

  if (!active?.data.current) {
    return null;
  }

  const activeAsset = active?.data.current?.classification;

  return (
    <DragOverlay>{activeAsset && <Item {...activeAsset} isDragging isEditable />}</DragOverlay>
  );
};
